export enum StepType {
  PAGE = 'PAGE',
  QUIZ_STEP = 'QUIZ_STEP',
}
